"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GridColumn_1 = require("./GridColumn");
exports.default = GridColumn_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Grid/GridColumn/index.js
// module id = 150
// module chunks = 8